var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"lighten-5",class:_vm.colorClass,attrs:{"small":""}},[_c('span',{staticClass:"font-weight-bold",domProps:{"textContent":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }